const mainMenuHover = () => {
	const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
	const menuItems = document.querySelectorAll(
		'.menu-principal .wp-block-navigation-item.has-child'
	);

	menuItems.forEach((menuItem) => {
		let closeTimer;

		menuItem.addEventListener('mouseenter', () => {
			if (!canHover.matches) {
				return;
			}

			window.clearTimeout(closeTimer);
			menuItem.classList.add('is-submenu-open');
		});

		menuItem.addEventListener('mouseleave', () => {
			if (!canHover.matches) {
				return;
			}

			window.clearTimeout(closeTimer);
			closeTimer = window.setTimeout(() => {
				menuItem.classList.remove('is-submenu-open');
			}, 300);
		});
	});
};

export { mainMenuHover };
